export default `State,Population
Aguascalientes,1184996
Baja California,3155070
Baja California Sur,637026
Campeche,822441
Chiapas,4796580
Mexico City,8918653
Chihuahua,3406465
Coahuila,2748391
Colima,650555
Durango,1632934
Guanajuato,5486372
Guerrero,3388768
Hidalgo,2665018
Jalisco,7350682
México,15175862
Michoacán,4351037
Morelos,1777227
Nayarit,1084979
Nuevo León,4653458
Oaxaca,3801962
Puebla,5779829
Querétaro,1827937
Quintana Roo,1325578
San Luis Potosí,2585518
Sinaloa,3216000
Sonora,2662480
Tabasco,2238603
Tamaulipas,3268554
Tlaxcala,1169936
Veracruz,7643194
Yucatán,1955577
Zacatecas,1490668`